import RegionSidebar from './RegionSidebar';
import ServiceSidebar from './ServiceSidebar';

export default {
    region: RegionSidebar,
    service: ServiceSidebar,
};
